import React from 'react';
import SelectStudentsTable from './Table';

const SelectStudents = () => {
  return <SelectStudentsTable />;
};

export default SelectStudents;
